module.exports = __webpack_public_path__ + "img/whisky-icon.a8ac99d8.svg";